/** Приземление TG-диплинка в DC-гриде (24.08, владелец): open_date переключает
 *  день сразу, open_booking открывает модалку когда сетка готова, open_client
 *  дополнительно раскрывает карточку клиента. Диплинк одноразовый (takeDeeplink);
 *  если брони в дне нет — гаснет без зацикливания. */
import { useCallback, useEffect, useRef, useState } from "react";
import type { Booking, BookingsMap, ModalState } from "./bookingTypes";
import { takeDeeplink } from "../utils/deeplink";

export function useGridDeeplink(
  dataReady: boolean,
  merged: BookingsMap,
  modal: ModalState | null,
  setModal: (m: ModalState) => void,
  setDate: (d: Date) => void,
) {
  const dl = useRef(takeDeeplink());
  const [dlClient, setDlClient] = useState(false);

  useEffect(() => {
    const d = dl.current?.date;
    if (d && /^\d{4}-\d{2}-\d{2}$/.test(d)) setDate(new Date(`${d}T00:00:00Z`));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const d = dl.current;
    if (!d || !dataReady || modal) return;
    for (const [key, v] of Object.entries(merged)) {
      if (v.type !== "auto-block" && (v as Booking).id === d.booking) {
        const i = key.lastIndexOf("_");
        dl.current = null;
        setDlClient(d.client);
        setModal({ questId: key.slice(0, i), time: key.slice(i + 1), booking: v as Booking, conflictLead: null, isNew: false });
        return;
      }
    }
    if (Object.keys(merged).length) dl.current = null; // день загружен, брони нет — гасим
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataReady, merged]);

  /* Императивный вход (24.08): «БЕЗ предоплаты» и др. списки открывают бронь
     через тот же эффект-приземление — sessionStorage не годится (dl-ref
     читается один раз при маунте, DcGridScreen не размонтируется). */
  const openBooking = useCallback((booking: number, date: string) => {
    dl.current = { booking, date, client: false };
    setDate(new Date(`${date}T00:00:00Z`));
  }, [setDate]);

  return { dlClient, clearDlClient: () => setDlClient(false), openBooking };
}
